import React, { Component, Fragment } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

// css
import './resources/assets/css/reset.css';
import './resources/assets/css/style.css';
// page

import NotFoundPage from './pages/NotePoundPage';
import HomePage from './pages/Home/HomePage';
import SignInPage from './pages/User/SignInPage';
import SignUpPage from './pages/User/SignUpPage';
import TermsPage from './pages/User/TermPage';
import HistoryPage from './pages/History/HistoryPage';
import HistoryWaitPage from './pages/History/HistoryWaitPage';
import SendPayHistoryPage from './pages/History/SendPay/SendPayHistoryPage';
import BonusHistory from './pages/History/Bonus/BonusHistoryPage';
import OrgChartPage from './pages/Chart/OrgChartPage';
import SendPage from './pages/Send/SendPage';
import PayPage from './pages/Pay/PayPage';
import ChangePassPage from './pages/User/ChangePassPage';
import FindIdPage from './pages/User/FindIdPage';
import SharePage from './pages/Share/SharePage';
import ScrollToTop from './modules/hooks/ScrollToTop';
import NoticePage from './pages/Notice/NoticePage';
// import { ProtectedRoute } from './modules/hooks/router.hook'

export default class App extends Component {
    render() {
        return (
            <Router>
                <Fragment>
                    <ScrollToTop />
                    <Switch>
                        <Route exact path="/" component={SignInPage} />
                        <Route path="/signup" component={SignUpPage} />
                        <Route path="/terms" component={TermsPage} />
                        <Route path="/home" component={HomePage} />
                        <Route path="/history" component={HistoryPage} />
                        <Route path="/historywait" component={HistoryWaitPage} />
                        <Route path="/bonus_history" component={BonusHistory} />
                        <Route path="/sphistory" component={SendPayHistoryPage} />
                        <Route path="/chart" component={OrgChartPage} />
                        <Route path="/send" component={SendPage} />
                        <Route path="/withdraw" component={PayPage} />
                        <Route path="/changepass" component={ChangePassPage} />
                        <Route path="/notice" component={NoticePage} />
                        <Route path="/findid" component={FindIdPage} />
                        <Route path="/share" component={SharePage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </Fragment>
            </Router>
        );
    }
}
